import React from 'react';

export class Forbidden extends React.Component {
  render() {
    return (
      <div>
        <h3>Permission Denied</h3>
        <p>Your account does not have access to this app. Please contact <a href='mailto:us-iasvsupport@abb.com'>us-iasvsupport@abb.com</a> to request access.</p>
      </div>
    );
  }
}
